module.exports = __webpack_public_path__ + "assets/media/drift_vertical_text.dea9c1aa.svg";